import { getInitials } from "../../utils/utilityFunctions/stringUtility";
import AvatarName from "../UniversalComponents/AvatarName";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";

const UserNameHover = ({ data, headerKey, handleClick }) => {
  console.log("key,,", headerKey, data);
  return (
    <div className="py-2 min-w-[17.78rem]">
      <div className="rounded-lg bg-white">
        <div className="border-b-2 space-y-2 pb-2">
          <div className="flex px-2 space-x-2">
            <div>
              <div className=" flex justify-center items-center  text-xs">
                {/* {getInitials(headerKey === "user_name" ? data.user_name : data.reporting)} */}
                <AvatarName
                  name={getInitials(headerKey === "user_name" ? data.user_name : data.reporting)}
                  size="small"
                  bgColor={"#E8ECF299"}
                  textColor={"#7C7C83"}
                  borderColor={"#ABABAC"}
                />
              </div>
            </div>
            <div className="text-2999BC text-14">
              {headerKey === "user_name" ? data.user_name : data.reporting || "-"}
            </div>
          </div>

          <div className="flex px-2 space-x-2 my-2">
            <div className="w-5 text-center">
              <EmailIcon />
            </div>
            <div className="text-F16136 text-12">{headerKey === "user_name" ? data.user_email : "N/A" || "N/A"}</div>
          </div>

          <div className="flex px-2 space-x-2 my-2">
            <div className="w-5 text-center">
              <PhoneIcon />
            </div>
            <div className="text-F16136 text-12">{data.phone || "N/A"}</div>
          </div>
        </div>
        <div className="flex justify-end mt-2 me-5 text-12">
          <button className="text-blue-500" onClick={() => handleClick()}>
            Show more
          </button>
        </div>
      </div>
    </div>
  );
};
export default UserNameHover;
